import type { PlaybackSettings, StemId } from './types';
export function processingFor(stem: StemId, settings: PlaybackSettings) {
  return { rate:settings.rate,semitones:stem==='click'?0:settings.semitones,formantCompensation:stem==='vocals',formantBaseHz:200 };
}
